import apiFetch from '../apiFetch'

export default function (token, extraSaleId) {
  return apiFetch({ endPoint: `ExtraSaleType/${extraSaleId}`, method: 'GET', body: null, token: token })
}
